import { cardFadeUp } from '@/core/constants/animations'
import { ROUTES } from '@/core/constants/routes'
import { Motion } from '@/core/ui/atoms/motion'
import { Link } from '@/i18n/navigation'
import Image from 'next/image'

type CityProps = {
  name: string
  slug: string
  image: string
  country: string
}

export const City: React.FC<CityProps> = ({ country, name, slug, image }) => {
  return (
    <Link
      href={ROUTES.city(slug)}
      aria-label={`${name}, ${country}`}
      prefetch={false}
    >
      <Motion
        type='div'
        className='relative h-full overflow-hidden rounded-md text-white'
        variants={cardFadeUp.variants}
        initial='initial'
        whileInView='animate'
        viewport={{ once: true, amount: 0.2 }}
        transition={cardFadeUp.transition}
      >
        <Image
          src={image}
          alt={`${name}, ${country}`}
          fill
          className='h-full w-full rounded object-cover'
        />
        <div className='absolute bottom-0 left-0 w-full rounded bg-[linear-gradient(180deg,rgba(8,51,88,0)_0%,rgba(8,51,88,0.64)_100%)] p-1'>
          <h4 className='text-xl font-bold'>{country}</h4>
          <p className='text-lg'>{name}</p>
        </div>
      </Motion>
    </Link>
  )
}
